// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingSetupIntentResponse

export type BillingSetupIntentApiResponse = {
	client_secret: string;
	connectedAccount: string | null;
};

export type BillingSetupIntent = {
	client_secret: string;
	connectedAccount: string | null;
};

export function hydrateBillingSetupIntent(data: BillingSetupIntentApiResponse): BillingSetupIntent {
	return { ...data };
}